import React, {useRef} from "react";
import {useSelector} from "react-redux";

//helpers:
import {useTranslation} from "react-i18next";
import {MinutesToTimestamp} from "../../../../../_metronic/_helpers";

//components:
import {makeStyles} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {CircularProgress} from "@material-ui/core";

//styles:
const topicsListStyles = makeStyles(theme => ({
    root: {
        width: "100%",
    },
    table: {
        minWidth: 500,
        marginBottom: "2rem",
    },
}));

const MetricsTable = ({features}) => {
    const classes = topicsListStyles();
    const {t} = useTranslation();

    const tableRef = useRef(null);

    const isLoadingMetricsTable = useSelector(state => state.settings.isLoadingMetricsTable);

    const onWheel = e => {
        e.preventDefault();
        const container = tableRef.current;
        const containerScrollPosition = tableRef.current.scrollLeft;

        container.scrollTo({
            top: 0,
            left: containerScrollPosition + e.deltaY,
        });
    };

    const desc = (a, b, orderBy) => {
        const aLowerCase = a[orderBy] || "";
        const bLowerCase = b[orderBy] || "";

        if (bLowerCase < aLowerCase) {
            return -1;
        }
        if (bLowerCase > aLowerCase) {
            return 1;
        }
        return 0;
    };

    const stableSort = (array, cmp) => {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = cmp(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        const stableSorted = stabilizedThis.map(el => el[0]);
        return stableSorted;
    };

    const getSorting = (order, orderBy) => {
        return order === "desc" ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
    };

    const headRows = [
        {
            id: "id",
            align: "left",
            disablePadding: false,
            label: "#",
        },
        {
            id: "name",
            align: "left",
            disablePadding: false,
            label: t("GENERAL.NAME").toUpperCase(),
        },
        {
            id: "minutes",
            align: "left",
            disablePadding: false,
            label: t("ADMINPANEL.METRICS.TOTAL_TIME"),
        },
        {
            id: "percentage",
            align: "right",
            disablePadding: false,
            label: "%",
        },
    ];

    if (isLoadingMetricsTable)
        return (
            <div className="d-flex justify-content-center align-items-center position-absolute top-0 left-0 w-100 h-100">
                <CircularProgress />
            </div>
        );

    return (
        <div className={classes.root}>
            <div className={`custom-scroll-area horizontal-scroll`} onWheel={onWheel} ref={tableRef}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            {headRows.map(row => (
                                <TableCell
                                    className="text-muted font-size-1rem"
                                    key={row.id}
                                    align={row.align}
                                    padding={row.disablePadding ? "none" : "default"}
                                >
                                    {row.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {stableSort(features, getSorting("desc", "percentage")).map(
                            ({name, minutes, percentage}, i) => (
                                <TableRow key={i}>
                                    {/* Column1: number */}
                                    <TableCell align="left" className="font-weight-bold text-muted mb-0 font-size-1rem">
                                        {i + 1}
                                    </TableCell>

                                    {/* Column2: name */}
                                    <TableCell align="left" component="th" scope="row">
                                        <div className="d-flex align-items-center">
                                            <span className="font-size-1rem">
                                                {name}
                                            </span>
                                        </div>
                                    </TableCell>

                                    {/* Column3: minutes: */}
                                    <TableCell align="left" className="font-weight-bold text-muted mb-0 font-size-1rem">
                                        <div className="d-flex align-items-center">{MinutesToTimestamp(minutes)}</div>
                                    </TableCell>

                                    {/* Column4: percentage: */}
                                    <TableCell align="right" className="font-weight-bold text-muted mb-0 w-100px">
                                        {percentage ? (
                                            typeof percentage === "number" ? (
                                                <div className="text-right w-90 mx-auto font-size-1rem">
                                                    {percentage.toFixed(2)}
                                                </div>
                                            ) : (
                                                percentage
                                            )
                                        ) : (
                                            "0"
                                        )}
                                    </TableCell>
                                </TableRow>
                            )
                        )}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};

export default MetricsTable;
